import { IPaginationInput } from '@models/payload/customer';
import {
  CategoryToppingsParams,
  CreateToppingCategoryPayload,
  CreateToppingPayload,
  UpdateToppingCategoryPayload,
  UpdateToppingPayload,
} from '@models/payload/topping';
import { ropoloRequest } from '@services/axios';

const getToppings = async (params: IPaginationInput) => (await ropoloRequest.catalogToppingcategoryList(params)).data;

const getToppingById = async (id: string) => (await ropoloRequest.catalogToppingcategoryDetail(id)).data;

const getToppingsByCategoryId = async (params: CategoryToppingsParams) =>
  (await ropoloRequest.catalogToppingList(params)).data;

const createToppingItem = async (command: CreateToppingPayload) =>
  (await ropoloRequest.snappfoodToppingCreate(command)).data;

const removeToppingItem = async (id: string) => (await ropoloRequest.snappfoodToppingDelete(id)).data;

const updateToppingItem = async (command: UpdateToppingPayload) =>
  (await ropoloRequest.snappfoodToppingUpdate(command)).data;

const createTopping = async (command: CreateToppingCategoryPayload) =>
  (await ropoloRequest.snappfoodToppingcategoryCreate(command)).data;

const updateTopping = async (command: UpdateToppingCategoryPayload) =>
  (await ropoloRequest.snappfoodToppingcategoryUpdate(command)).data;

const removeTopping = async (id: string) => (await ropoloRequest.snappfoodToppingcategoryDelete(id)).data;

const syncToppingCategoryWithSnapp = async (id: string) =>
  (await ropoloRequest.snappfoodToppingcategorySendToSnappFoodUpdate(id)).data;

const changeToppingAvailability = async (id: string) =>
  (await ropoloRequest.snappfoodToppingUpdateAvailableUpdate({ id })).data;

const searchToppingTitle = async (search: string) => (await ropoloRequest.catalogToppingBranchList({ search })).data;

const toppingService = {
  getToppings,
  createTopping,
  getToppingById,
  removeTopping,
  updateTopping,
  getToppingsByCategoryId,
  createToppingItem,
  removeToppingItem,
  updateToppingItem,
  syncToppingCategoryWithSnapp,
  changeToppingAvailability,
  searchToppingTitle,
};

export default toppingService;
